import styled from 'styled-components';

export const CenterCointer = styled.div`
  display: flex;
  flex-direction: column;
`;
CenterCointer.displayName = 'CenterCointer';

export const Container = styled.section`
  font-family: 'Roboto', sans-serif;
  font-size: 36px;
  font-weight: 900;
  margin: 16px 36px;
  position: relative;
`;
Container.displayName = 'Container';

export const FlagContainerAway = styled.svg`
  right: -33px;
  position: absolute;
  top: -7px;
`;
FlagContainerAway.displayName = 'FlagContainerAway';

export const FlagContainerHome = styled.svg`
  left: -33px;
  position: absolute;
  top: -7px;
`;
FlagContainerHome.displayName = 'FlagContainerHome';

export const Points = styled.div`
  color: #4cb2ae;
  line-height: 56px;
  min-width: 45px;
`;
Points.displayName = 'Points';

export const PointsContainer = styled.div`
  align-items: center;
  background-color: #ffffff;
  color: #4cb2ae;
  display: flex;
  justify-content: center;
  text-align: center;
  width: 120px;
`;
PointsContainer.displayName = 'PointsContainer';

export const Space = styled.div`
  font-size: 30px;
  position: relative;
  top: -2px;
`;
Space.displayName = 'Space';

export const TeamContainer = styled.div`
  display: flex;
  height: 56px;
`;
TeamContainer.displayName = 'TeamContainer';

export const TeamName = styled.div`
  align-items: center;
  background: #82182e;
  color: #ffffff;
  display: flex;
  font-style: normal;
  justify-content: center;
  line-height: 56px;
  padding: 0 16px;
`;
TeamName.displayName = 'TeamName';

export const TeamNameAway = styled(TeamName)`
  justify-content: flex-start;
  padding-right: 75px;
`;
TeamNameAway.displayName = 'TeamNameAway';

export const TeamNameHome = styled(TeamName)`
  justify-content: flex-end;
  padding-left: 75px;
`;
TeamNameHome.displayName = 'TeamNameHome';

export const TimerContainer = styled.div`
  align-items: center;
  background-color: #82182e;
  box-sizing: content-box;
  display: flex;
  height: 56px;
  justify-content: center;
  width: 120px;
`;
TimerContainer.displayName = 'TimerContainer';

export const Timer = styled.div`
  color: #ffffff;
  font-style: normal;
  letter-spacing: 0.03em;
  line-height: 56px;
  text-align: center;
`;
Timer.displayName = 'Timer';
